import styled from 'styled-components';
import {Label} from '../../atoms/Label/index';
import {LoginIcon,MenuHamburger} from '../../atoms/Icons';
import Dropdown from '../../atoms/Dropdown';
import ContainedButton from '../../atoms/ContainedButton/index';
import Signup from '../../molecules/Signup';
import {Mushi1Logo,SignInWithGoogleLogo} from '../../atoms/Logo';
import { DarkPrimaryColor,OnPrimary,OnSurface,LightPrimaryColor,Primary500,Primary300,Alpha30 } from '../../Colors';
import TextButton,{TextButtonBase} from '../../atoms/TextButton';
import IconButton from '../../atoms/IconButton';
import patternImg from '../../images/wood-texture_00015.jpg';

const defaultStyle =  {
	Wrapper : styled.div`
        display : flex;
        justify-content : space-between;
        padding : 1rem;
        background-image : ${`url(${patternImg})`};
        border-bottom : 1px solid ${Primary500};
    `,
	Leftside : styled.div`
        position : relative;
    `,
	Rightside : styled.div`
        align-items : right;
    `,
	Brand : styled(Label)`
        padding-left : 4rem;
        display : inline-block;
        color : ${LightPrimaryColor};
        font-size : 2rem;
        margin-left : 0.5rem;
        margin-right : 0.1rem;
        font-family: 'Courier','Helvetica Neue','Helvetica','Arial',sans-serif;
        position : relative;
        cursor : pointer;
    `,
	UserText : styled.span`
        margin-left : 1rem;
        margin-right : 1rem;
        color : ${OnPrimary+Alpha30};
        `,
	LoginText : styled(TextButtonBase)`
        color : ${OnPrimary};
        white-space: nowrap;
        border-radius : 3px;
        display : flex;
        align-items : center;
    `,
	AppMenuWrapper : styled.div`
        display : flex;
        align-items : center;
    `,
	UserWrapper : styled.div`
        margin-left : 2rem;
        color : ${OnPrimary};
        white-space: nowrap;
        border-radius : 3px;
    `,
	Avatar : styled.img`
        width : 2.5rem;
        height : 2.5rem;
        border-radius : 50%;
    `,
	LoginIcon : styled(LoginIcon)`
        font-size : 2rem;
        margin-right : 1rem;
    `,
	AppMenu : styled(Dropdown).attrs({
		Wrapper : styled(Dropdown.Wrapper)`
            color : ${LightPrimaryColor};
            white-space: nowrap;
            border-radius : 3px;
        `,
		Content : styled(Dropdown.Content)`
            background-color : ${DarkPrimaryColor};
            padding : 0.5rem 1rem 0.5rem 1rem;
            border : 1px dotted ${LightPrimaryColor};
        `,
		Button : styled(Dropdown.Button)`
            position : relative;
            padding-right : 2rem;
            &::before{
                font-family: "Font Awesome 5 Free";
                pointer-events: none;
                font-weight: 900;
                z-index: 1;
                position: absolute;
                right:0;
                top: 5%;
                content: "\f107";
                color: ${LightPrimaryColor};
            }
        `
	})`
    `,
	AppMenuItem : styled(TextButtonBase)`
        display : inline-block;
        color : ${OnPrimary};
        padding : 0.5rem;
        border-radius : 5px;
        &:focus{
            background-color : ${Primary300};
            color : ${OnPrimary};
        }
        &:hover{
            color : ${OnPrimary};
            background-color : ${Primary300};
        }
        &:disabled{
            background-color : transparent;
            color : ${OnPrimary};
        }
    `,
	AppMenuIconWrapper : styled.span`
        margin-left : 1rem;
        margin-right : 1rem;
    `,
	DropdownMenuItem : styled(TextButtonBase)`
        display : block;
        color : ${OnPrimary};
        text-align : left;
        &:focus{
            background-color : ${Primary300};
            color : ${OnPrimary};
        }
        &:hover{
            color : ${OnPrimary};
            background-color : ${Primary300};
        }
        &:disabled{
            background-color : transparent;
            color : ${OnPrimary};
        }
    `,
	Mushi1Logo : styled(Mushi1Logo).attrs({
		width : '30px',
		height : '30px',
	})`
        position : absolute;
        top : 0;
        left : 0;
    `,
	SignInWithGoogleLogo : styled(SignInWithGoogleLogo)`
        width : 80%;
    `,
	Signup
};

const mobileStyle = {
	Wrapper : styled.div`
        background-image : ${`url(${patternImg})`};
        border-bottom : 1px solid ${Primary500};
        padding : 1rem;
    `,
	Header : styled.div`
        display : flex;
        justify-content : space-between;
        width : 100%;
    `,
	ModalHeader : styled.div`
        text-align : center;
        font-size : 2rem;
    `,
	Footer : styled.div`
        text-align : center;
        font-size : 2rem;
    `,
	IconButton : styled(IconButton)`
        font-size :2rem;
        margin : auto;
        padding-right : 3rem;
        color : ${LightPrimaryColor};
    `,
	MenuItemWrapper : styled.div`
        font-size : 2rem;
        text-align : center;
        padding : 0.5rem 0 0.5rem 0;
        color : ${OnSurface};
    `,
	MenuItem : styled(TextButtonBase)`
       
    `,
	MenuHamburger,
	ContainedButton,
	TextButton
};

export default defaultStyle;
export {mobileStyle};